// No imports needed

export const customizeFilterDebounceUiSchema = {
  type: "HorizontalLayout",
  elements: [
    {
      type: "Control",
      scope: "#/properties/keyword",
      component: "searchInput",
      placeholder: "Type to Search keyword",
    },
  ],
};

export const customizeFilterDebounceJsonSchema = {
  type: "object",
  properties: {
    keyword: {
      type: "string",
      title: "Search",
    },
  },
};

export const customizedRewardsFilterUiSchema = {
  type: "HorizontalLayout",
  elements: [
    {
      type: "Control",
      scope: "#/properties/isActive",
      component: "multipleSelectPerformanceList",
      selection: "single",
      placeholder: "Status",
      label: "Status",
    },
    {
      type: "Control",
      scope: "#/properties/startDate",
      component: "dateTimePicker",
      label: " Start Date",
    },
    {
      type: "Control",
      scope: "#/properties/endDate",
      component: "dateTimePicker",
      label: " End Date",
    },
  ],
};

export const customizedRewardsFilterJsonSchema = {
  type: "object",
  properties: {
    isActive: {
      items: {
        type: "boolean",
        options: [
          {
            id: true,
            displayText: "Active",
          },
          {
            id: false,
            displayText: "Inactive",
          },
        ],
      },
    },
    startDate: {
      type: "string",
      format: "date",
      title: "Start Date",
    },
    endDate: {
      type: "string",
      format: "date",
      title: "End Date",
    },
  },
};
